import React from 'react';
import styles from '../irlObservations2026.module.css';
import { ModalShell } from '../chrome';

export default function IRL_AI_Review_Review_Response_4({ onLeave }) {
    return (
        <ModalShell width="small">
            <div className={styles.modalBody}>
                <div className={styles.progressBars}>
                    <span className={styles.bar} />
                    <span className={styles.bar} />
                    <span className={styles.bar} />
                    <span className={styles.bar} />
                    <span className={styles.bar} />
                    <span className={styles.bar} />
                    <span className={styles.bar} />
                </div>
                <h2 className={styles.progressTitle}>AI Review in progress</h2>
                <p className={styles.progressCopy}>Reviewing requests, responses, Ready attachments and authorised evidence. You can leave this screen — we will email you when the review is ready.</p>
                <div className={styles.progressStep}>
                    <span className={styles.stepDone}>✓</span>
                    Preparing evidence
                </div>
                <div className={styles.progressStep}>
                    <span className={styles.stepDone}>✓</span>
                    Reviewing responses
                </div>
                <div className={styles.progressStep}>
                    <span className={styles.stepActive}>
                        <span className={styles.stepActiveDot} />
                    </span>
                    Finding gaps
                </div>
                <div className={`${styles.progressStep} ${styles.stepMuted}`}>
                    <span className={styles.stepTodo} />
                    Preparing suggestions
                </div>
                <div className={`${styles.modalFoot} ${styles.modalFootFlush}`}>
                    <button type="button" className={styles.mutedBtn} onClick={onLeave}>
                        Leave this screen
                    </button>
                </div>
            </div>
        </ModalShell>
    );
}
